<p-tabView [(activeIndex)]="activeTabIndex">
  <!-- ITEM TAB -->
  <p-tabPanel header="Item" i18n-header="@@itemTab" [disabled]="currentlyEditingTab !== null && currentlyEditingTab !== 0">
    <div *ngIf="currentlyEditingTab === 0; else itemViewMode" style="max-width: 640px">
      <app-item-form
        [formGroup]="itemForm"
        reportType="SRE"
        [deleteable]="false"
        (classificationSelect)="onClassificationSelect($event)">
      </app-item-form>

      <app-sre-photo-grid
        [photos]="editedPhotos"
        [required]="true"
        [showError]="photoError"
        (photosChange)="onPhotosChange($event)">
      </app-sre-photo-grid>

      <div *ngIf="saveFailed" style="color: red; margin-top: 1rem">
        <ng-container i18n="@@sre.saveFailed">The changes could not be saved. Please try again.</ng-container>
      </div>

      <div style="display: flex; justify-content: space-between; margin-top: 1rem">
        <button
          pButton
          label="Cancel"
          i18n-label="@@cancelButton"
          class="p-button-sm p-button-text"
          (click)="cancelEdit()"
          type="button">
        </button>

        <button
          pButton
          label="Save"
          i18n-label="@@saveButton"
          class="p-button-sm p-button-primary"
          (click)="saveItemTab()"
          [loading]="isSaving"
          type="button">
        </button>
      </div>
    </div>

    <ng-template #itemViewMode>
      <app-input-display-grid [values]="itemRows" [columnLength]="2"></app-input-display-grid>

      <div style="margin-top: 1rem; max-width: 640px">
        <app-sre-photo-grid [photos]="storedPhotos" [editable]="false"></app-sre-photo-grid>
      </div>

      <div style="margin-top: 1rem; text-align: right">
        <button
          *ngIf="canEdit"
          pButton
          icon="ri-pencil-line"
          class="p-button-sm p-button-primary"
          (click)="editTab(0)"
          type="button"
          label="Edit"
          i18n-label="@@editButton">
        </button>
      </div>
    </ng-template>
  </p-tabPanel>

  <!-- DETAILS TAB -->
  <p-tabPanel header="Details" i18n-header="@@sre.detailsTab" [disabled]="currentlyEditingTab !== null && currentlyEditingTab !== 1">
    <div *ngIf="currentlyEditingTab === 1; else detailsViewMode">
      <app-sre-details-form [formGroup]="detailsForm"></app-sre-details-form>

      <div *ngIf="saveFailed" style="color: red; margin-top: 1rem">
        <ng-container i18n="@@sre.saveFailed">The changes could not be saved. Please try again.</ng-container>
      </div>

      <div style="display: flex; justify-content: space-between; max-width: 600px">
        <button
          pButton
          label="Cancel"
          i18n-label="@@cancelButton"
          class="p-button-sm p-button-text"
          (click)="cancelEdit()"
          type="button">
        </button>

        <button
          pButton
          label="Save"
          i18n-label="@@saveButton"
          class="p-button-sm p-button-primary"
          (click)="saveDetailsTab()"
          [loading]="isSaving"
          type="button">
        </button>
      </div>
    </div>

    <ng-template #detailsViewMode>
      <app-input-display-grid [values]="detailRows" [columnLength]="2"></app-input-display-grid>

      <div style="margin-top: 1rem; text-align: right">
        <button
          *ngIf="canEdit"
          pButton
          icon="ri-pencil-line"
          class="p-button-sm p-button-primary"
          (click)="editTab(1)"
          type="button"
          label="Edit"
          i18n-label="@@editButton">
        </button>
      </div>
    </ng-template>
  </p-tabPanel>
</p-tabView>
